import React from "react";
import { Box, Card, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { htmlDecode } from "src/utils/convertHtml";
import CustomPopover from "./CustomPopover";
import { useContentSetting } from "src/Hooks/ContentSettingState";

const ImageStyle = styled("img")({
  top: 0,
  width: "100%",
  height: "auto",
  objectFit: "cover",
});

// ----------------------------------------------------------------------

export default function CustomMUICard({
  data,
  handleClick,
  MENU_OPTIONS,
  className,
  lockStatement,
}) {
  const pathName = window.location.pathname.includes("/my-live-events");
  const { userInfo } = useContentSetting();
  return (
    <div className={`row ${className}`}>
      {data.map((item, index) => {
        return (
          <div className={item.card_classes} key={index}>
            <Card className="mui-custom-card h-100" sx={{ cursor: "pointer" }}>
              <Box
                sx={{
                  position: "relative",
                  cursor: "pointer",
                }}
              >
                {item.card_button && item.card_button.button_title && (
                  <button
                    variant="contained"
                    className={
                      lockStatement
                        ? `small-contained-button mui-card-button d-flex centerAlignProgram ${
                            index == 0 ? "centerAlignProgram" : ""
                          }`
                        : "small-contained-button mui-card-button mui-card-button-program d-flex centerAlignProgram"
                    }
                    onClick={
                      item.card_button.handleClick
                        ? () => {
                            item.card_button.handleClick(item);
                          }
                        : undefined
                    }
                  >
                    {item.card_button.button_title}
                  </button>
                )}
                <ImageStyle
                  alt={item.title}
                  src={item.card_image}
                  onClick={
                    handleClick
                      ? () => {
                          handleClick(item);
                        }
                      : undefined
                  }
                />
              </Box>
              {pathName && item.action_id === userInfo._id
                ? MENU_OPTIONS && (
                    <div className="mui-custom-card-dots">
                      <CustomPopover menu={MENU_OPTIONS} data={item} />
                    </div>
                  )
                : !pathName
                ? MENU_OPTIONS && (
                    <div className="mui-custom-card-dots">
                      <CustomPopover menu={MENU_OPTIONS} data={item} />
                    </div>
                  )
                : ""}
              <Stack
                spacing={2}
                className="mui-custom-card-content"
                onClick={
                  handleClick
                    ? () => {
                        handleClick(item);
                      }
                    : undefined
                }
              >
                <h3 className="pe-4">{htmlDecode(item.card_title)}</h3>
                {item.card_short_description && (
                  <p className="mui-custom-card-description">
                    {htmlDecode(item.card_short_description)}
                  </p>
                )}
                {item.card_short_description_2 && (
                  <p className="card_lower_title_description">
                    {htmlDecode(item.card_short_description_2)}
                  </p>
                )}
                {item.card_gray_description && (
                  <p className="mui_gray_description">
                    <span>{item.card_gray_description}</span>
                  </p>
                )}
              </Stack>
            </Card>
          </div>
        );
      })}
    </div>
  );
}
